import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M21 19H3V17H21V19ZM21 15H3V13H21V15ZM21 11H3V9H21V11ZM21 7H3V5H21V7Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "TextAlignJustify"
);
